





/*===========================================================
=============================================================
             GSAP 初期化とフレームワーク作成
=============================================================
===========================================================*/


/*		GSAPの初期化
=============================== */

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, TextPlugin);




/*	ScrollSmootherの初期化（effects: true のまま）
=============================== */

ScrollSmoother.create({
  wrapper: '#smooth-wrapper', // ラッパーのID
  content: '#smooth-content', // コンテンツのID
  smooth: 1.6,                // スムーススクロールの長さ（秒）
  effects: true,              // data-speed と data-lag 属性を利用
  smoothTouch: 0            // タッチデバイスでのスムーズスクロール
});


 /* ScrollTriggerを使ってクラスの付与を行う
 =============================== */

  gsap.utils.toArray('.inview').forEach(section => {
    ScrollTrigger.create({
      trigger: section,
      start: "top 85%",
      end: "60% top",
      toggleClass: {targets: section, className: "in-view"}, // クラスの付与と削除
      markers: false // デバッグ用マーカーの非表示
    });
  });



/* ページが完全に読み込まれた後にScrollTriggerとScrollSmootherをリフレッシュ
=============================== */

window.addEventListener('load', () => {
  ScrollSmoother.get().refresh();
  ScrollTrigger.refresh();
});



/* ScrollToPluginを使ってアンカーリンクを制御
=============================== */

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault(); // デフォルトのアンカーリンクの動作を無効化

    const targetID = this.getAttribute('href'); // クリックされたリンクのhrefを取得
    const targetElement = document.querySelector(targetID); // ターゲット要素を取得

    if (targetElement) {
      // ターゲット要素のページ内の座標を取得
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

      // ScrollToPluginを使ってスムーズにスクロール
      gsap.to(window, {
        scrollTo: {
          y: targetPosition, // ターゲット要素のY座標にスクロール
          autoKill: false,    // autoKillを無効にしてスクロールを完了させる
          allowTouchMove: true // モバイルデバイスのタッチスクロールを許可
        },
        duration: 1.5,        // スクロールのスムーズさ
        ease: 'power2.inOut', // スムーズなスクロールのイージング
        overwrite: true       // 現在のスクロールアニメーションを上書き
      });
    }
  });
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault(); // デフォルトの動作を無効化

    const targetID = this.getAttribute('href'); // クリックされたリンクのhrefを取得

    if (targetID === '#') {
      // 最上部にスクロール
      gsap.to(window, {
        scrollTo: {
          y: 0, // 最上部にスクロール
          autoKill: false,
          allowTouchMove: true
        },
        duration: 1.5,
        ease: 'power2.inOut',
        overwrite: true
      });
    } else {
      const targetElement = document.querySelector(targetID); // ターゲット要素を取得

      if (targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        gsap.to(window, {
          scrollTo: {
            y: targetPosition,
            autoKill: false,
            allowTouchMove: true
          },
          duration: 1.5,
          ease: 'power2.inOut',
          overwrite: true
        });
      }
    }
  });
});



/* 横方向のパララックスを適用　.parallax-itemと[data-speed-x]
=============================== */

gsap.utils.toArray(".parallax-item").forEach(item => {
  const speedX = item.dataset.speedX || 0; // 横方向のspeed（デフォルトは0）

  gsap.to(item, {
    x: () => window.innerWidth * speedX, // 正の値で右方向、負の値で左方向
    scrollTrigger: {
      trigger: item,
      start: "top bottom",
      end: "bottom top",
      scrub: true
    }
  });
});



/* 画面中央で止まるアニメーション　[data-vertical-speed][data-horizontal-speed]
=============================== */

document.querySelectorAll("[data-vertical-speed], [data-horizontal-speed]").forEach((elem) => {
  const verticalSpeed = elem.getAttribute("data-vertical-speed");
  const horizontalSpeed = elem.getAttribute("data-horizontal-speed");

  // 縦方向のアニメーション
  if (verticalSpeed) {
    gsap.from(elem, {
      yPercent: -100 * parseFloat(verticalSpeed),
      ease: "none",
      scrollTrigger: {
        trigger: elem,
        start: "top bottom", // 要素の上部がビューポートの下部に来たとき
        end: "top center", // 要素の下部がビューポートの中央に来たとき
        scrub: true, // スクロールに同期
      }
    });
  }

  // 横方向のアニメーション
  if (horizontalSpeed) {
    gsap.from(elem, {
      xPercent: 100 * parseFloat(horizontalSpeed),
      ease: "none",
      scrollTrigger: {
        trigger: elem,
        start: "top bottom", // 要素の上部がビューポートの下部に来たとき
        end: "bottom center", // 要素の下部がビューポートの上部に来たとき
        scrub: true, // スクロールに同期
      }
    });
  }
});



/* .typing_effectを持つ要素すべてに対してタイピングエフェクトを適用
=============================== */

gsap.utils.toArray(".typing_effect").forEach(item => {
  // 元のHTMLテキストを取得（<br>を含む）
  const originalHTML = item.innerHTML;

  // 要素のテキストをクリア
  item.innerHTML = "";

  // タイピングエフェクトの適用とScrollTriggerの設定
  gsap.to(item, {
    duration: 1.5, // アニメーションの時間
    text: originalHTML, // そのままHTMLをアニメーションで表示
    ease: "none", // タイピング効果なのでイージングなし
    scrollTrigger: {
      trigger: item, // 個々の要素がトリガー
      start: "top center", // 要素のtopが画面のcenterに来たときに発火
      toggleActions: "play none none none", // スクロールのアクション
    }
  });
});



/*===========================================================
=============================================================
             GSAP jQuery 個別アニメーションの設計
=============================================================
===========================================================*/


/* 要素の出現アニメーション
=============================== */

gsap.utils.toArray('.kakikomi > span').forEach((span) => {
  gsap.to(span, 
    { 
      opacity: 1, 
      filter: "none", 
      duration: 2.5,
      scrollTrigger: {
        trigger: span,
        start: "top 75%",  // spanの上端が画面の75%に来た時に発火
        toggleActions: "play none none none",  // アニメーションの発火を設定
        once: true  // 一度発火したら再び発火しない
      }
    }
  );
});






/* 紙芝居アニメーション
=============================== */

// タッチデバイスかどうかを判別
const isTouchDevice = window.matchMedia("(hover: none)").matches;

// タッチデバイスの場合、各要素に.is_touchクラスを追加
if (isTouchDevice) {
  const targets = ['#fv', '#diary', '#memo', '#memob', '#memoc', '#diaryb', '#diaryc', '#lineup'];
  
  targets.forEach(target => {
    const element = document.querySelector(target);
    if (element) {
      element.classList.add('is_touch');
    }
  });
}

// #fv のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#fv",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #diary のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#diary",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #memo のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#memo",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #memob のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#memob",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #memoc のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#memoc",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #diaryb のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#diaryb",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #diaryc のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#diaryc",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}

// #lineup のピン止め設定
if (!isTouchDevice) {
  ScrollTrigger.create({
    trigger: "#lineup",
    start: "bottom bottom",
    pin: true,
    pinSpacing: false,
    scrub: true,
    end: () => `+=${window.innerHeight * 2}`,
  });
}






/* toTop
=============================== */
jQuery(document).ready(function($) {
    var $toTop = $('#totop');
    var lastScrollTop = 0;
    var windowHeight = $(window).height();

    $(window).on('scroll', function() {
        var scrollTop = $(this).scrollTop();
        var docHeight = $(document).height();

        // 上にスクロールした時にクラスを追加
        if (scrollTop < lastScrollTop) {
            $toTop.addClass('totop_on');
        } else {
            // 下にスクロールした時はクラスを削除
            $toTop.removeClass('totop_on');
        }

        // 画面上部1スクロール分の範囲が表示されている時は常にクラスを削除
        if (scrollTop <= 1) {
            $toTop.removeClass('totop_on');
        }

        // 画面下部から1スクロール分の範囲が表示されている時は常にクラスを追加
        if (scrollTop + windowHeight >= docHeight - windowHeight) {
            $toTop.addClass('totop_on');
        }

        lastScrollTop = scrollTop;
    });
});



/* #agvideo 内の動画が指定の場所に到達したら再生、離れたら停止
=============================== */

const scrollVideoElement = document.querySelector('#agvideo video'); // 変数名を変更

ScrollTrigger.create({
  trigger: "#agvideo",       // #agvideo をトリガーに設定
  start: "top 75%",          // #agvideo の上端がウィンドウの75%に到達した時に開始
  end: "bottom 25%",         // #agvideo の下端がウィンドウの25%に到達したら終了
  onEnter: () => scrollVideoElement.play(),    // 表示されたら動画を再生
  onLeave: () => scrollVideoElement.pause(),   // 離れたら一時停止
  onEnterBack: () => scrollVideoElement.play(), // 逆方向にスクロールして再度表示されたら再生
  onLeaveBack: () => scrollVideoElement.pause() // 逆方向に離れたら一時停止
});

$(document).ready(function() {
    const $video = $('#agvideo video');
    const $soundOn = $('#agvideo_sound_on');
    const $soundOff = $('#agvideo_sound_off');

    // 音声ONボタンのクリックイベント
    $soundOn.on('click', function() {
        $video.prop('muted', false); // 音声ON
        $soundOn.addClass('agvideo_now'); // ONボタンにクラスを追加
        $soundOff.removeClass('agvideo_now'); // OFFボタンからクラスを削除
    });

    // 音声OFFボタンのクリックイベント
    $soundOff.on('click', function() {
        $video.prop('muted', true); // 音声OFF
        $soundOff.addClass('agvideo_now'); // OFFボタンにクラスを追加
        $soundOn.removeClass('agvideo_now'); // ONボタンからクラスを削除
    });
});





/* cartボタンのアニメーション
=============================== */

gsap.utils.toArray(".cart > a > img").forEach(function(img) {
  gsap.to(img, {
    scale: 1.5, // 150%に拡大
    duration: 0.2, // 拡大する時間
    yoyo: true,  // 戻すための設定
    repeat: 1,  // 拡大して縮小の繰り返しを1回行う
    ease: "power1.inOut", // なめらかな動き
    scrollTrigger: {
      trigger: img.parentElement, // .cart > a 要素が中央に来た時に発火
      start: "center center", // .cart > a が画面中央に来た時に発火
    },
  });
});





/*===========================================================
=============================================================
             ローディングアニメーション
=============================================================
===========================================================*/

/* ページが読み込まれた後にローディング画面だけを表示し、他のコンテンツを非表示に */


document.addEventListener("DOMContentLoaded", function() {
    
    document.body.classList.add('no-scroll');
    document.querySelector("#smooth-wrapper").style.opacity = 0;  // メインコンテンツを非表示に

    // ScrollSmootherがある場合はスクロールを停止
    if (ScrollSmoother && ScrollSmoother.get()) {
        ScrollSmoother.get().paused(true);
    }


    // ローディングアニメーション
    gsap.timeline()
        .to("#loadinga", {
            duration: 0.3,
            delay: 0.2,
            filter: "blur(0px)",
            opacity: 1 
        })
        .to("#loadingb", {
            duration: 0.8,
            delay: 0.2,
            filter: "blur(0px)",
            opacity: 1 
        })
        .to("#loading", {
            duration: 0.5,    
            delay: 1.5,       // 3秒後にローディング画面フェードアウト開始 3.5秒後に消える
            opacity: 0
        })
        .add(function() {
            // ローディング画面を非表示にする
            document.querySelector("#loading").style.display = "none";
        })
        .to("#smooth-wrapper", {
            duration: 0.5,    // メインコンテンツを3.5から4にかけて表示
            opacity: 1
        })
        .add(function() {
            // スクロール禁止解除
            document.body.classList.remove('no-scroll');

            // ScrollSmootherのスクロールを再開
            if (ScrollSmoother && ScrollSmoother.get()) {
                ScrollSmoother.get().paused(false);
            }
        })
        .to(".fv_one", {
            duration: 1,
            delay: 0.5,
            filter: "blur(0px)", 
            opacity: 1 
        })
        .to(".fv_two", {
            duration: 0.5,
            delay: 0,
            filter: "blur(0px)", 
            opacity: 1 
        })
        .to(".fv_three", {
            duration: 0.5,
            delay: 0,
            filter: "blur(0px)", 
            opacity: 1 
        })
        .to(".fv_four", {
            duration: 0.5,
            delay: 0,
            filter: "blur(0px)", 
            opacity: 1 
        })
        .to(".fv_five", {
            duration: 0.5,
            delay: 0,
            filter: "blur(0px)", 
            opacity: 1 
        })
        .to(".fv_six", {
            duration: 0.5,
            delay: 0,
            filter: "blur(0px)", 
            opacity: 1 
        });
});

// スクロール禁止のスタイルをCSSで指定
document.querySelector("style").innerHTML += `
  body.no-scroll {
    overflow: hidden;
  }
`;




















